import {ReactNode, DragEvent, RefObject, useState, useCallback} from 'react';
import cx from 'classnames';

import './FileDropZone.sass';

interface FileDropZoneProps {
  children?: ReactNode;
  inputRef: RefObject<HTMLInputElement>;
  hasBorder?: boolean;
  disabled?: boolean;
}

export const FileDropZone = ({
  children,
  inputRef,
  hasBorder = false,
  disabled = false,
}: FileDropZoneProps) => {
  const [dragging, setDragging] = useState(false);

  const onDragOver = useCallback((e: DragEvent) => {
    e.preventDefault();
    setDragging(true);
  }, []);

  const onDragLeave = useCallback((e: DragEvent) => {
    e.preventDefault();
    setDragging(false);
  }, []);

  const onDrop = useCallback(
    (e: DragEvent) => {
      e.preventDefault();
      setDragging(false);

      if (!inputRef.current || disabled) return;

      // Build a new file list from dropped files
      const dt = new DataTransfer();
      Array.from(e.dataTransfer.files).forEach((file) => dt.items.add(file));

      // Assign to the input and fire its change event
      // eslint-disable-next-line no-param-reassign
      inputRef.current.files = dt.files;
      inputRef.current.dispatchEvent(new Event('change', {bubbles: true}));
    },
    [inputRef, disabled]
  );

  return (
    <div
      className={cx('file-dropzone', {
        'file-dropzone--hover': dragging,
        'file-dropzone--has-border': hasBorder,
      })}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      aria-label="File drag-n-drop zone"
    >
      {children}
    </div>
  );
};
